<template>
  <div>
    <Card shoaw>
      <i-col>
        <Modal
          footer-hide
          v-model="chartScreenModal"
          width="90%">
          <div class="title" :style="{textAlign: 'center', padding: '25px'}">
            <b><span id="chartScreenId_title" :style="{fontSize: '16px'}">{{ chartScreenIdTitle }}</span></b>
          </div>
          <div :style="{height: '500px'}" id="chartScreenId"></div>
        </Modal>
        <i-form :model="graphFilter" ref="graphFilter" label-position="left" inline>
          <form-item>
            <radio-group v-model="graphFilter.selectTime" type="button" @on-change="lastTimeChange">
              <radio label="3600">1小时</radio>
              <radio label="21600">6小时</radio>
              <radio label="43200">12小时</radio>
              <radio label="86400">1天</radio>
              <radio label="259200">3天</radio>
              <radio label="604800">7天</radio>
              <radio label="2592000">1月</radio>
            </radio-group>
          </form-item>
          <FormItem>
            <DatePicker
              v-model="customTime"
              type="datetimerange"
              style="min-width: 250px;"
              format="yyyy-MM-dd HH:mm"
              @on-ok="customTimeChange"
              @on-clear="customTimeClear"
              placeholder="自定义时间"></DatePicker>
          </FormItem>
          <form-item>
            <i-select v-model="dbType" placeholder="数据库类型" style="min-width: 100px;" :transfer="true"
                      @on-change="changeGraph">
              <i-option v-for="item in dbTypeList" :value="item.value" :key="item.value" :label="item.label"></i-option>
            </i-select>
          </form-item>
          <form-item class="mob-align-right">
            <Button type="primary" @click="changeGraph" icon="md-refresh">刷新</Button>
          </form-item>
        </i-form>
        <div id="monitor_card">
          <div v-for="item in monitorData" v-bind:key="item.id">
            <Col :span="24" :md="monitorColSpan" :style="{marginBottom: '10px'}">
              <Col span="24" :md="23">
                <Card>
                  <p slot="title">
                    <span :id="'graph_id_' + item.id + '_title'">{{ item.title }}</span>
                    <span :style="{float : 'right'}">
                        <Button type="text" @click="chartScreen(item)" size="small">
                          <Icon type="md-expand" size="16"/>
                        </Button>
                      </span>
                  </p>
                  <div :id="'graph_id_' + item.id" :style="graphDivStyle"></div>
                </Card>
              </Col>
            </Col>
          </div>
        </div>
      </i-col>
    </Card>
  </div>

</template>

<script>
import {getEndpointMonitorData} from '@/api/monitor'
import {getInstanceList as mysqlInstanceList} from '@/api/mysql'
import {getInstanceList as mongodbInstanceList} from '@/api/mongodb'
// import {getInstanceList as sqlserverInstanceList} from '@/api/sqlserver'

import echarts from '../../../view/monitor/components/echarts-use.js'
import { valueTranUnit } from '@/libs/tools'

let option = {
  title: {
    text: ''
  },
  grid: {
    x: 40,
    x2: 40,
    left: 60
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {}
    }
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    show: true,
    icon: 'rect',
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 15,
    y: 'bottom',
    type: 'scroll'
  },
  xAxis: {
    type: 'time',
    splitLine: {
      show: true
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true
    },
    axisLabel: {
      formatter: function (value) {
        return valueTranUnit(value, 0)
      }
    }
  },
  series: []
}
export default {
  name: 'databaseDashboard',
  data () {
    return {
      monitorTheme: 'dark',
      customTime: '',
      dbTypeList: [
        {
          value: 'MySQL',
          label: 'MySQL'
        },
        {
          value: 'SQLSERVER',
          label: 'SQLSERVER'
        },
        {
          value: 'MongoDB',
          label: 'MongoDB'
        }
      ],
      dbType: 'MySQL',
      graphFilter: {
        angle: 'merge',
        cf: 'AVERAGE',
        sum: false,
        sumonly: false,
        selectTime: '3600',
        start: '',
        end: ''
      },
      monitorIndex: 0,
      monitorData: [],
      chartScreenModal: false,
      chartScreenIdTitle: '',
      monitorColSpan: 12,
      graphDivStyle: {
        height: '300px'
      },
      mysqlCounter: ['Com_insert', 'Com_select', 'Com_update', 'Com_delete', 'Threads_connected', 'Threads_running', 'Bytes_received', 'Bytes_sent', 'max_connections', 'innodb_buffer_pool_size', 'Innodb_buffer_pool_bytes_dirty', 'Innodb_buffer_pool_write_requests', 'Innodb_buffer_pool_pages_flushed', 'Innodb_buffer_pool_read_requests', 'Innodb_buffer_pool_reads'],
      sqlserverCounter: [],
      mongodbCounter: ['opcounters_insert', 'opcounters_query', 'opcounters_update', 'opcounters_delete', 'opcounters_getmore', 'opcounters_command', 'connections_used_percent', 'network_bytesIn', 'network_bytesOut', 'network_numRequests', 'mem_resident', 'mem_virtual', 'wt_cache_dirty_bytes', 'wt_cache_used_total_bytes'],
      endpointList: [],
      counterList: [],
      portList: []
    }
  },

  mounted: function () {
    this.changeGraph()
  },

  methods: {
    changeGraph () {
      let that = this
      that.monitorData = []
      that.monitorIndex = 0
      if (that.dbType === 'MySQL') {
        that.getMySQLEndpoint()
        that.mysqlCounter.forEach(function (item, index) {
          that.getMySQLCounter(item)
        })
      } else if (that.dbType === 'MongoDB') {
        that.getMongoDBEndpoint()
        that.mongodbCounter.forEach(function (item, index) {
          that.getMongoDBCounter(item)
        })
      }
    },

    getMySQLEndpoint () {
      let that = this
      that.endpointList = []
      let params = {
        page: this.page
      }
      mysqlInstanceList(params).then(res => {
        res.data.results.forEach(function (item, index) {
          that.endpointList.push(item.server)
          that.portList.push(item.port)
        })
      })
    },

    getMySQLCounter (name) {
      let that = this
      let params = {
        page: this.page
      }
      mysqlInstanceList(params).then(res => {
        that.counterList = []
        res.data.results.forEach(function (item, index) {
          that.counterList.push(name + '/' + 'port=' + item.port + ',type=mysql')
        })
        that.drawGraph(that.endpointList, that.counterList, name)
      })
    },

    getMongoDBEndpoint () {
      let that = this
      that.endpointList = []
      let params = {
        page: this.page
      }
      mongodbInstanceList(params).then(res => {
        res.data.results.forEach(function (item, index) {
          that.endpointList.push(item.server)
        })
      })
    },

    getMongoDBCounter (name) {
      let that = this
      let params = {
        page: this.page
      }
      mongodbInstanceList(params).then(res => {
        that.counterList = []
        res.data.results.forEach(function (item, index) {
          that.counterList.push(name + '/' + 'mongo=' + item.port)
        })
        that.drawGraph(that.endpointList, that.counterList, name)
      })
    },

    drawGraph (endpoints, counters, name) {
      let that = this
      let reqData = {
        'last': that.graphFilter.selectTime,
        'angle': that.graphFilter.angle,
        'cf': that.graphFilter.cf,
        'sum': that.graphFilter.sum,
        'sumonly': that.graphFilter.sumonly,
        'start': that.graphFilter.start,
        'end': that.graphFilter.end
      }
      reqData.endpoints = endpoints
      reqData.counters = counters
      this.monitorIndex++
      reqData.id = this.monitorIndex
      reqData.title = name
      this.monitorData.push(reqData)
      that.getGraphData(reqData, 'graph_id_' + this.monitorIndex)
    },

    getGraphData (reqData, graphId) {
      let that = this
      getEndpointMonitorData(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          // if (result.data.title) {
          //   reqData.title = result.data.title
          // }
          let data = result.data.series
          let dseries = []
          let haveArea = false
          let monitorTheme = this.monitorTheme
          if (monitorTheme.endsWith('-line')) {
            monitorTheme = monitorTheme.split('-line')[0]
          } else {
            haveArea = true
          }
          for (let v in data) {
            let dSeriesConfig = {
              name: data[v].name,
              data: data[v].data,
              type: 'line',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1
                  }
                }
              }
            }
            if (haveArea) {
              dSeriesConfig.areaStyle = {
                opacity: 0.2
              }
            }
            dseries.push(dSeriesConfig)
          }
          option.series = dseries
          let graphLine = echarts.init(document.getElementById(graphId), monitorTheme)
          window.addEventListener('resize', function () {
            graphLine.resize()
          })
          graphLine.clear()
          graphLine.setOption(option, true)
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！',
            desc: result.msg
          })
        }
      }).catch(res => {
        that.table_current_page = 1
        that.table_total = 1
        if (res.request) {
          this.$Notice.error({
            title: '获取监控数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！服务器无响应'
          })
        }
      })
    },

    chartScreen (data) {
      this.chartScreenModal = true
      this.graphFilter = data
      this.graphFilter.selectTime = data.last + ''
      this.chartScreenIdTitle = data.title
      this.getGraphData(data, 'chartScreenId')
    },
    lastTimeChange () {
      this.customTime = ''
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.changeGraph()
    },
    customTimeChange () {
      let timeRange = [this.customTime[0].getTime() / 1000, this.customTime[1].getTime() / 1000]
      if (timeRange[0] && timeRange[1]) {
        this.graphFilter.selectTime = ''
        this.graphFilter.start = timeRange[0]
        this.graphFilter.end = timeRange[1]
      } else {
        this.graphFilter.selectTime = '3600'
        this.graphFilter.start = ''
        this.graphFilter.end = ''
      }
      this.changeGraph()
    },
    customTimeClear () {
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.graphFilter.selectTime = '3600'
      this.changeGraph()
    }
  }
}
</script>

<style>
  #monitor_card .ivu-card-body {
    padding: 0;
  }

  #monitor_card .ivu-card-head {
    background-color: #F2F2F2;
    height: 30px;
    padding: 0;
  }

  #monitor_card .ivu-card-head p {
    padding-left: 10px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }

  .ivu-poptip-body {
    text-align: left !important;
  }

  @media screen and (max-width:640px){
    .ivu-radio-group-button .ivu-radio-wrapper{
      padding: 0 9.6px;
    }
    .ivu-form-item-content >.ivu-date-picker{
      width: 100%;
    }
  }
</style>
